import React from 'react';
import CodeMirror from '@uiw/react-codemirror';
import { StreamLanguage } from '@codemirror/language';
import { showMinimap } from '@replit/codemirror-minimap';
import { createTheme } from '@uiw/codemirror-themes';
import {
    StateField, StateEffect,
} from '@codemirror/state';
import { tibbobasic } from '@appblocks/frontend/client/monarch/codemirror-tibbobasic';
import { jsonld as json, javascript } from '@codemirror/legacy-modes/mode/javascript';
import { c, cpp } from '@codemirror/legacy-modes/mode/clike';
import { cmake } from '@codemirror/legacy-modes/mode/cmake';
import { html } from '@codemirror/legacy-modes/mode/xml';
import { python } from '@codemirror/legacy-modes/mode/python';
import { tags as t } from '@lezer/highlight';

const theme = createTheme({
    theme: 'dark',
    settings: {
        background: '#1e1e1e',
        backgroundImage: '',
        foreground: '#fff',
        caret: '#e6db74',
        selection: '#4e6e80',
        selectionMatch: '#036dd626',
        // lineHighlight: '#1e1e1e',
        gutterBackground: '#1e1e1e',
        gutterForeground: '#4e6e80',
    },
    styles: [
        { tag: t.comment, color: '#608b4e' },
        { tag: t.variableName, color: '#ffff' },
        { tag: [t.string, t.special(t.brace)], color: '#ce9169' },
        { tag: t.number, color: '#b5cea8' },
        { tag: t.bool, color: '#569cd6' },
        { tag: t.null, color: '#569cd6' },
        { tag: t.keyword, color: '#c586c0' },
        { tag: t.operator, color: '#ffff' },
        { tag: t.punctuation, color: '#ffff' },
        { tag: t.className, color: '#66d9ef' },
        { tag: t.definition(t.typeName), color: '#5c6166' },
        { tag: t.typeName, color: '#66d9ef' },
        { tag: t.angleBracket, color: '#ffff' },
        { tag: t.tagName, color: '#5c6166' },
        { tag: t.attributeName, color: '#5c6166' },
        { tag: t.moduleKeyword, color: '#e6db74' },
    ],
    '&': {
        fontFamily: 'Roboto Mono, Monaco, courier, monospace',
    },
});

const create = (v) => {
    const dom = document.createElement('div');
    return { dom };
};

const CodeMirrorWrapper = ({
    language, extensions, minimap, codeMirrorRef, ...props
}) => {
    let mode = null;
    switch (language) {
        case 'tibbobasic':
            mode = tibbobasic;
            break;
        case 'javascript':
            mode = javascript;
            break;
        case 'json':
            mode = json;
            break;
        case 'cpp':
            mode = cpp;
            break;
        case 'c':
            mode = c;
            break;
        case 'cmake':
            mode = cmake;
            break;
        case 'html':
            mode = html;
            break;
        case 'python':
            mode = python;
            break;
        default:
            mode = null;
            break;
    }

    if (extensions) {
        if (mode) {
            extensions.push(StreamLanguage.define(mode));
        }
        if (minimap) {
            extensions.push(showMinimap.compute(['doc'], (state) => {
                return {
                    create,
                    showOverlay: 'mouse-over',
                    /* optional */
                };
            }));
        }
    }

    return (
        <CodeMirror
            {...props}
            ref={codeMirrorRef}
            extensions={extensions}
            theme={theme}
        />
    );
};

export default CodeMirrorWrapper;
